/**
 * Created by anatoly on 20.12.2024
 */

const MergeComponentView = function (component, unitView) {
    this.component = component;
    this.unitView = unitView;
};

MergeComponentView.prototype.cleanAnimations = function (unitView) {
    if (unitView.raysAnimation) {
        unitView.raysAnimation.setAnimation(0, "close", false);
        unitView.raysAnimation.setCompleteListenerRemove();
        delete unitView.raysAnimation;

        unitView.restoreOpacity();
    }

    if (unitView.mergeAnimateAction && !unitView.mergeAnimateAction.isDone()) {
        unitView.stopAction(unitView.mergeAnimateAction);
        delete unitView.mergeAnimateAction;
    }

    if (unitView.mergeAnimation && !unitView.mergeAnimation.isDone()) {
        unitView.stopAction(unitView.mergeAnimation);
        delete unitView.mergeAnimation;
    }

    if (unitView.spawnAction && !unitView.spawnAction.isDone()) {
        unitView.stopAction(unitView.spawnAction);
        delete unitView.spawnAction;
    }
};

MergeComponentView.prototype.stopHighlight = function (cb) {
    this.cleanAnimations(this.unitView);

    if (this.hintAnimation) {
        this.hintAnimation = false;

        const mapView = Merge2.current.field.getMapView();
        const position = mapView.alignInGrid(this.unitView.unit.x, this.unitView.unit.y);

        this.unitView.mergeAnimateAction = this.unitView.runAction(new cc.Spawn(
            new cc.MoveTo(0.1, position.x, position.y),
            new cc.ScaleTo(0.1, 1, 1)
        )).setFinalize(() => {
            cb && cb();
            this.unitView.setPosition(position);
            this.unitView.setScale(1);
        });
    }
};

MergeComponentView.prototype.startAnimateMerge = function () {
    this.cleanAnimations(this.unitView);

    const rays = new cleverapps.Spine(bundles.merge.jsons.merge_rays_json);
    this.unitView.addChild(rays, -1);
    rays.setAlignment({ align: "center" }, { align: "center" });
    rays.setAnimationAndIdleAfter("open", "idle");

    this.unitView.raysAnimation = rays;
    this.unitView.setImageOpacity(255, true);
};

MergeComponentView.prototype.startAnimateHint = function (targetUnit, options) {
    options = options || {};

    this.cleanAnimations(this.unitView);

    this.hintAnimation = true;

    this.unitView.mergeAnimateAction = this.unitView.runAction(new cc.Sequence(
        new cc.DelayTime(options.delay || 0),
        new cc.CallFunc(() => {
            const baseScaleX = this.unitView.getScaleX();
            const baseScaleY = this.unitView.getScaleY();

            const delta = 0.2;

            const distance = this.calculateDistance(this.component.unit, targetUnit);
            const dx = distance.dx;
            const dy = distance.dy;

            this.unitView.mergeAnimateAction = this.unitView.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.CallFunc(() => {
                    options.onCycle && options.onCycle();
                }),
                new cc.Spawn(
                    new cc.Sequence(
                        new cc.MoveBy(0.4, dx, dy).easing(cc.easeIn(1)),
                        new cc.MoveBy(0.25, -delta * dx, -delta * dy),
                        new cc.MoveBy(0.25, delta * dx, delta * dy),
                        new cc.MoveBy(0.4, -dx, -dy).easing(cc.easeOut(1))
                    ),
                    new cc.Sequence(
                        new cc.ScaleTo(0.4, baseScaleX * 1.1, baseScaleY * 1.1).easing(cc.easeIn(1)),
                        new cc.DelayTime(0.5),
                        new cc.ScaleTo(0.4, baseScaleX, baseScaleY).easing(cc.easeOut(1))
                    )
                ),
                new cc.DelayTime(options.interval || 0.3)
            )));
        })
    ));
};

MergeComponentView.prototype.calculateDistance = function (affectedUnit, target) {
    const mapView = Merge2.current.field.getMapView();
    const targetPosition = mapView.alignInGrid(target.x, target.y);

    const x = affectedUnit.x;
    const y = affectedUnit.y;

    const position = mapView.alignInGrid(x, y);

    let dx = targetPosition.x - position.x;
    let dy = targetPosition.y - position.y;

    const length = Math.sqrt(dx * dx + dy * dy);
    if (length <= 0) {
        return { dx: 0, dy: 0 };
    }

    dx = dx / length * cleverapps.styles.MergeComponentView.highlightLength;
    dy = dy / length * cleverapps.styles.MergeComponentView.highlightLength;

    return { dx, dy };
};

MergeComponentView.prototype.removeMergeUnit = function (unit, silent) {
    const unitView = unit.onGetView();
    if (!unitView) {
        return;
    }

    this.cleanAnimations(unitView);

    if (silent) {
        unitView.removeFromParent();
        return;
    }

    unitView.mergeAnimation = unitView.runAction(new cc.Sequence(
        new cc.ScaleTo(0.15, 0.7).easing(cc.easeBackIn()),
        cleverapps.effects.fireAction(`merge.effect.${Math.min(unit.stage, 5)}`)
    )).setFinalize(() => {
        unitView.removeFromParent();
    });
};

MergeComponentView.prototype.spawnMergeUnit = function (unit, pivotUnit, callback) {
    const unitView = unit.onGetView();
    if (!unitView) {
        callback();
        return;
    }

    this.cleanAnimations(unitView);

    unitView.setVisible(false);
    unitView.setScale(0.7);
    
    const particles = new cleverapps.Spine(bundles.merge_animations.jsons.merge_particles);
    particles.setAlignment(unitView.width / 2, unitView.height / 2);
    particles.setCompleteListenerRemove();
    particles.setSafeToRemove();
    particles.setAnimation(0, this.chooseMergeParticlesAnimation(unit, particles), false);
    unitView.addChild(particles, -1);

    unitView.mergeAnimation = unitView.runAction(new cc.Sequence(
        new cc.DelayTime(0.15),
        new cc.Show(),
        new cc.ScaleTo(0.15, 1.15).easing(cc.easeInOut(2)),
        new cc.ScaleTo(0.15, 1).easing(cc.easeInOut(2))
    )).setFinalize(() => {
        unitView.setVisible(true);
        unitView.setScale(1);
        callback();
    });
};

MergeComponentView.prototype.chooseMergeParticlesAnimation = function (unit, particles) {
    const listAnimations = particles.listAnimations();

    if (listAnimations.length === 1) {
        return listAnimations[0];
    }

    if (unit.stage >= 7) {
        return listAnimations[2];
    }
    if (unit.stage >= 4) {
        return listAnimations[1];
    }

    return listAnimations[0];
};

cleverapps.styles.MergeComponentView = {
    merge: 16,
    highlightLength: 28
};